import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator to ensure the value follows the "City, Country" format
 * 
 * Usage in Reactive Forms:
 * this.form = this.fb.group({
 *   headquarters: ['', [Validators.required, CityCountryFormatValidator()]],
 * });
 * 
 * Display error in template:
 * <small *ngIf="form.get('headquarters')?.hasError('cityCountryFormat')" class="p-error">
 *   Rispettare il formato: Città, Nazione
 * </small>
 */

/**
 * Validator function for ensuring "City, Country" format
 * @returns ValidatorFn
 */
export function CityCountryFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // Don't validate empty values (use Validators.required)
    }

    const value = control.value.toString().trim();

    // Check if the value contains exactly one comma
    const commaCount = (value.match(/,/g) || []).length;
    
    if (commaCount === 0) {
      return {
        cityCountryFormat: {
          value: value,
          message: 'Rispettare il formato: Città, Nazione',
        },
      };
    }

    if (commaCount > 1) {
      return {
        cityCountryFormat: {
          value: value,
          message: 'Rispettare il formato: Città, Nazione (una sola virgola)',
        },
      };
    }

    // Split by comma and check both parts are not empty
    const [city, country] = value.split(',').map((part: string) => part.trim());

    if (!city || !country) {
      return {
        cityCountryFormat: {
          value: value,
          message: 'Rispettare il formato: Città, Nazione',
        },
      };
    }

    // Optional: Check minimum length for city and country
    if (city.length < 2 || country.length < 2) {
      return {
        cityCountryFormat: {
          value: value,
          message: 'Rispettare il formato: Città, Nazione',
        },
      };
    }

    return null;
  };
}
